export enum EnumCopiedFrom {
  IsFromOrder = 1,
  IsFromQuote = 2,
}
